import type { Tokens } from '../augmentation'
import { type ComponentCreation } from './types'

export const createMuiFormLabel = ({ palette }: Pick<Tokens, 'palette'>) =>
  ({
    MuiFormLabel: {
      styleOverrides: {
        root: {
          '&.Mui-focused': {
            // prevent color to switch to primary whenever an item within gets the focus
            color: 'inherit',
          },
          '& .MuiFormLabel-asterisk': {
            color: palette.error.main,
          },
        },
      },
    },
  }) satisfies ComponentCreation
